import { useFormikContext } from 'formik'
import { Button, Checkbox, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { TextInputWithHelper } from 'src/components'
import { useStyles } from './style'
import { ICreateWhiteLabelPartnerDto } from 'src/types/white-label-partners.type'

interface IProps {
  isEditing?: boolean
}

export const WhiteLabelPartnersForm = ({ isEditing }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { errors, values, handleChange, isSubmitting, dirty } =
    useFormikContext<ICreateWhiteLabelPartnerDto>()
  const classes = useStyles()

  return (
    <div className={`${classes.formWrapper} ${isEditing ? '' : classes.formWrapperWithHeight}`}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>
          {isEditing ? (
            <HelperWrapper t="white-label-partners-form-edit" ns={ETranslationNs.Common} />
          ) : (
            <HelperWrapper t="white-label-partners-form-create" ns={ETranslationNs.Common} />
          )}
        </Typography>
        <div className={classes.inputsWrapper}>
          <TextInputWithHelper
            inputName="name"
            handleChange={handleChange}
            value={values.name}
            error={errors.name ? t(errors.name + '.v') : ''}
            inputPlaceholder={t('white-label-partners-name-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-name-input'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
          />
          <div className={classes.imageHolder} style={{ backgroundImage: `url(${values.logo})` }} />
          <TextInputWithHelper
            inputName="logo"
            handleChange={handleChange}
            value={values.logo}
            inputPlaceholder={t('white-label-partners-logo-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-logo-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <TextInputWithHelper
            inputName="primary_color"
            handleChange={handleChange}
            value={values.primary_color}
            inputPlaceholder={t('white-label-partners-primary-color-placeholder.v').toLowerCase()}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-primary-color-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <TextInputWithHelper
            inputName="secondary_color"
            handleChange={handleChange}
            value={values.secondary_color}
            inputPlaceholder={t('white-label-partners-secondary-color-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-secondary-color-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <TextInputWithHelper
            inputName="alternative_color"
            handleChange={handleChange}
            value={values.alternative_color}
            inputPlaceholder={t('white-label-partners-alternative-color-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-alternative-color-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <TextInputWithHelper
            inputName="journey_link"
            handleChange={handleChange}
            value={values.journey_link}
            inputPlaceholder={t('white-label-partners-journey-url-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-journey-url-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <TextInputWithHelper
            inputName="qr_code_logo"
            handleChange={handleChange}
            value={values.qr_code_logo}
            inputPlaceholder={t('white-label-partners-qr-code-url-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-qr-code-url-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <TextInputWithHelper
            inputName="footer"
            handleChange={handleChange}
            value={values.footer}
            inputPlaceholder={t('white-label-partners-footer-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-footer-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <TextInputWithHelper
            inputName="footer_url"
            handleChange={handleChange}
            value={values.footer_url}
            inputPlaceholder={t('white-label-partners-footer-url-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-footer-url-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <TextInputWithHelper
            inputName="footer_color"
            handleChange={handleChange}
            value={values.footer_color}
            inputPlaceholder={t('white-label-partners-footer-color-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'white-label-partners-footer-color-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
          <div className={classes.checkboxWrapper}>
            <HelperWrapper t="white-label-partners-hide-billing" />
            <Checkbox
              id="billing_hidden"
              color="primary"
              checked={values.billing_hidden ?? false}
              name="billing_hidden"
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <Button
        variant="contained"
        disabled={isSubmitting || !dirty || !!Object.keys(errors).length}
        type="submit"
      >
        {isEditing ? (
          <HelperWrapper t="white-label-partners-update-submit-button" />
        ) : (
          <HelperWrapper t="white-label-partners-create-submit-button" />
        )}
      </Button>
    </div>
  )
}
